export default class CustomWoocommerce {
  // html selector for the component
    static selectorString()
    {
        return '.woocommerce';
    }

    constructor(rootNode)
    {

        jQuery(document).ready(function ($) {

            $('.icheckbox_minimal-grey.disabled').closest('li').hide();

            jQuery('.woof_container_checkbox .woof_container_inner ul').each(function () {
                var menu = jQuery(this);
                if (menu.children(':hidden').length === menu.children().length) {
                    jQuery(this).parents('.woof_container_checkbox').hide();
                }
            });

          /**
           * Redirect to selected variation
           */
            jQuery('.variations_form').
            on('woocommerce_variation_has_changed', function (e) {
                const variationId = jQuery(".variation_id").val();
                if( variationId ) {
                    let url_parameters = '?variation=' + variationId;
                    jQuery("[data-attribute_name]").each(function() {
                        url_parameters = url_parameters + '&' + jQuery(this).data('attribute_name') + '=' + jQuery(this).val();
                    });
                    $('.price-wrap').css('opacity', '0');
                    $('.single_variation_wrap').fadeOut(1000);
                    window.location.search = url_parameters;
                }

                /*
                const variationId = jQuery(".variation_id").val();
                const color = jQuery("#pa_farbe").val();
                const material = jQuery("#pa_beschlaege").val();
                const wert = jQuery("#pa_wert").val();
                const set = jQuery("#pa_set").val();
                let colorUrl = '';
                let materialUrl = '';
                let wertUrl = '';
                let setUrl = '';
                if (variationId) {
                    if (color) {
                        colorUrl = '&attribute_pa_farbe=' + color;
                    }
                    if (material) {
                        materialUrl = '&attribute_pa_beschlaege=' + material;
                    }
                    if (wert) {
                        wertUrl = '&attribute_pa_wert=' + wert;
                    }
                    if (set) {
                        setUrl = '&attribute_pa_set=' + set;
                    }
                    $('.price-wrap').css('opacity', '0');
                    $('.single_variation_wrap').fadeOut(1000);
                    window.location.search = '?variation=' + variationId + colorUrl + materialUrl + wertUrl + setUrl;
                }*/
            });

            $(".single_variation_wrap").on("show_variation", function ( event, variation ) {
              // Hide cart button
                if (variation.is_in_stock) {
                    $('.single_add_to_cart_button').show();
                    $('.cart_contact').hide();
                } else {
                    $('.single_add_to_cart_button').hide();
                    $('.cart_contact').show();
                }

              // Hide sale badge
                if (!variation.sale || variation.hideBadge === 'yes') {
                    $('.sale-badge').hide();
                } else {
                    $('.sale-badge').show();
                }

                initVariationSwatches();
            });

          /**
           * Activate zoom function on product detail slick slider
           */
          // ZOOM
            jQuery('.woocommerce .slick-zoom').zoom();

          /**
           * Variant swatches
           */
            initVariationSwatches();

        });

        function setVariationImage(_this)
        {

            var slick_slider = _this.
            closest('article').
            find('.product-slider');

            var imageId = null;
            if (_this.attr('current-image')) {
                imageId = _this.attr('current-image');
            }

            if (imageId && slick_slider.length > 0) {
                var attachment = slick_slider.find(
                    '[attachment-id="' + imageId + '"]'
                );
                if (attachment.length > 0) {
                    slick_slider.slick(
                        'slickGoTo',
                        attachment.closest('.slick-slide').attr('data-slick-index')
                    );
                }
            }

        }

        function initVariationSwatches()
        {

            jQuery('.variations-swatch').each(function () {

                var swatch = jQuery(this);
                var input = swatch.next('select');
                var options = [];
                var available_options = [];
                var selected = null;

                input.find('option').each(function () {
                    var val = jQuery(this).attr("value");
                    if (val) {
                        available_options.push(val);
                    }
                    if (jQuery(this).is(':selected')) {
                        selected = val;
                    }
                });


                swatch.find('.swatch').each(function () {
                    var val = jQuery(this).attr("data-value");
                    if (val) {
                        options.push(val);
                    }

                    jQuery(this).removeClass("disabled");
                    jQuery(this).removeClass("active");

                    if (!inArray(val, available_options)) {
                        jQuery(this).addClass("disabled");
                    }

                    if (val === selected) {
                        jQuery(this).addClass("active");
                        var title = jQuery(this).attr('data-title');
                        jQuery('.color-title').text('Farbe: ' + title);
                    }

                    jQuery(this).off("click.variation_swatch").on("click.variation_swatch", function () {
                        input.val(jQuery(this).attr("data-value"));
                        input.trigger("change");
                    });

                });

            });

        }

        function inArray(needle, haystack)
        {
            var length = haystack.length;
            for (var i = 0; i < length; i++) {
                if (haystack[i] == needle) {
                    return true;
                }
            }
            return false;
        }

    }

}
